import { Carousel } from '@belong/ui';

import { TermsAndConditions } from 'lease-signing-flow-v2/components/terms-and-conditions/terms-and-conditions';
import { WalletFeatureItem } from 'lease-signing-flow-v2/components/wallet-feature-item/wallet-feature-item';
import { features } from 'lease-signing-flow-v2/constants/wallet';

export const WalletFeatureCarousel = () => (
  <div className="mt-xl">
    <Carousel>
      {features.map((feature, index) => (
        <div className="flex min-w-full justify-center" key={index}>
          <div>
            <WalletFeatureItem
              description={feature.description}
              image={feature.image}
              title={feature.title}
            />
          </div>
        </div>
      ))}
    </Carousel>
    <div className="mt-xl text-center md:hidden">
      <TermsAndConditions />
    </div>
  </div>
);
